// Fancy nav reveal with circle clip
$('#nav-icon').on('click', (e) => {
    $(e.currentTarget).toggleClass('open');
    $('body').toggleClass('nav-expanded');
    $('.active-clip-animation').toggleClass('reveal');
});
